export const TYPES = {
  SET_ONBOARD_HAS: "onboard/SET_ONBOARD_HAS",
};
